module.exports = __webpack_public_path__ + "img/image-mobile.b9851c24.svg";